import { XStack, YStack } from '@frontend/web-react/components/Primitives/Containers';
import { Text } from '@frontend/web-react/components/Primitives/Texts/Text';
import type { RadioProps as MRadioProps } from '@mantine/core';
import { Radio as MRadio } from '@mantine/core';

type RadioProps = Pick<MRadioProps, 'description' | 'label'> & {
  value: MaybeUndefined<string>;
};

export const Radio = ({ description, label, value }: RadioProps) => {
  return (
    <MRadio.Card className="p-md hover-background-effect border-none" radius="md" tabIndex={undefined} value={value}>
      <XStack gap="sm">
        <MRadio.Indicator
          className="size-md mt-xs"
          classNames={{
            icon: 'size-[4px]',
          }}
          color="slate.6"
          iconColor="neutral.0"
          size="sm"
        />
        <YStack>
          <Text type={description ? 'h5' : 'p-md'}>{label}</Text>
          {description ? (
            <Text color="secondary" type="p-sm">
              {description}
            </Text>
          ) : null}
        </YStack>
      </XStack>
    </MRadio.Card>
  );
};
